const MODULE = 'OPTIONS';

export const TERMS = 'TERMS';
export const GROUP_SETS = 'GROUP_SETS';

export const REDUCER_KEY = 'optionsReducer';
export const GET_TERMS = `${MODULE}_GET_${TERMS}`;
export const GET_GROUP_SETS = `${MODULE}_GET_${GROUP_SETS}`;
export const SELECT_DATA = `${MODULE}_SELECT_DATA`;
